import React, {createContext, useContext} from 'react';

export type RunSelectorAnalyticsLocation =
  | 'report'
  | 'runs-table'
  | 'workspace'
  | 'create-sweep-prior-runs'
  | 'sweep-prior-runs'
  | 'full-screen-panel-view';

type RunSelectorAnalyticsLocationContextProps = {
  location: RunSelectorAnalyticsLocation;
  children: React.ReactNode;
};

const RunSelectorAnalyticsLocationContext = createContext<
  RunSelectorAnalyticsLocation | undefined
>(undefined);

export const RunSelectorAnalyticsLocationProvider = ({
  children,
  location,
}: RunSelectorAnalyticsLocationContextProps) => {
  return (
    <RunSelectorAnalyticsLocationContext.Provider value={location}>
      {children}
    </RunSelectorAnalyticsLocationContext.Provider>
  );
};

export const useRunSelectorAnalyticsLocation = () => {
  const value = useContext(RunSelectorAnalyticsLocationContext);
  if (!value) {
    throw new Error(
      'useRunSelectorAnalyticsLocation must be used within a RunSelectorAnalyticsLocationContext'
    );
  }
  return value;
};
